import { InjectionToken } from '@angular/core';
import type { AuthEnvironment } from '@env/environment.model';

export type { ApplicationModuleConfig, AuthEnvironment } from '@env/environment.model';

export const AUTH_ENV = new InjectionToken<AuthEnvironment>('AUTH_ENV');
